import { Button } from '@blueprintjs/core';
import React, { useState, useContext } from 'react';
import styled from 'styled-components';

import { ElemsContext, StatElems } from '@auravisionlabs/aura-react';
import { areaContext, lineContext } from '/src/services/api';

const ButtonContainer = styled.div`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  gap: 1em;
`;

const saveAreaContext = async (
  context,
  recording,
  fetch
) => {
  const response = await areaContext.create(context, recording.id);

  if (response && response.id) {
    fetch(recording.id);
  }
};

const saveLineContext = async (
  context,
  recording,
  fetch
) => {
  const response = await lineContext.create(context, recording.id);

  if (response && response.id) {
    await fetch(recording.id);
  }
};

export const CreateStandardElems = ({
    compact,
    handleSaveChanges,
}) => {
  const [loading, setLoading] = useState(false);
  const { recording, elems, setElems, fetch, setSelected } = useContext(ElemsContext);

  const is_loading = loading || !elems;
  let names = elems ? elems.elems.map(a => a.name) : [];

  let name_idx = 0;
  while (names.includes(`entry-${name_idx}`)) {name_idx += 1}
  const entryName = `entry-${name_idx}`;

  name_idx = 0;
  while (names.includes(`passer-by-${name_idx}`)) {name_idx += 1}
  const passerName = `passer-by-${name_idx}`;

  name_idx = 0;
  while (names.includes(`dwell-${name_idx}`)) {name_idx += 1}
  const dwellName = `dwell-${name_idx}`;

  return (
    <ButtonContainer>
      <Button
        loading={is_loading}
        onClick={async () => {
          setLoading(true);
          elems.addDefault("lines", entryName);
          setElems(new StatElems(elems.scale, elems.elems));
          await handleSaveChanges();
          await saveLineContext(
            {
              type: 'location-entry',
              actions: [
                [
                  {
                    lineId: entryName,
                    direction: 'in',
                    crossed: true,
                  },
                  {
                    lineId: entryName,
                    direction: 'out',
                    crossed: false,
                  },
                ],
              ],
              metadata: [],
            },
            recording,
            fetch
          );
          setLoading(false);
        }}
      >
        {compact ? "+ Entry" : "+ Entry Line"}
      </Button>
      <Button
        loading={is_loading}
        onClick={async () => {
          setLoading(true);
          elems.addDefault("lines", passerName, { vari: 0 });
          setElems(new StatElems(elems.scale, elems.elems));
          await handleSaveChanges();
          await saveLineContext(
            {
              type: 'location-pass-by',
              actions: [
                [
                  {
                    lineId: passerName,
                    direction: 'out',
                    crossed: true,
                  },
                  {
                    lineId: passerName,
                    direction: 'in',
                    crossed: false,
                  },
                ],
                [
                  {
                    lineId: passerName,
                    direction: 'out',
                    crossed: false,
                  },
                  {
                    lineId: passerName,
                    direction: 'in',
                    crossed: true,
                  },
                ],
              ],
              metadata: [],
            },
            recording,
            fetch
          );
          setLoading(false);
        }}
      >
        {compact ? "+ Passer By" : "+ Passer By Line"}
      </Button>
      <Button
        loading={is_loading}
        onClick={async () => {
          setLoading(true);
          elems.addDefault("areas", dwellName);
          setElems(new StatElems(elems.scale, elems.elems));
          await handleSaveChanges();
          await saveAreaContext(
            {
              areaId: dwellName,
              type: 'location-dwell',
            },
            recording,
            fetch
          );
          setLoading(false);
        }}
      >
        {compact ? "+ Dwell" : "+ Dwell Area"}
      </Button>
    </ButtonContainer>
  );
};
